import { ReactNode } from 'react';
import logo from '../../assets/logo.png';
import { LinkProps, LinkTypes } from '../../components/Link';
import Section from '../../components/Section';
import Button from '../../components/Button';
import Card from '../../components/Card';
import styles from './CardLayout.module.scss';

interface CardLayoutProps<T extends LinkTypes> {
  children: ReactNode;
  back?: LinkProps<T>;
}

function CardLayout<T extends LinkTypes>({
  children,
  back,
}: CardLayoutProps<T>) {
  return (
    <Section
      containerClassName={styles.container}
      className={styles.content}
      as="main"
    >
      <Card backgroundColor="background-1" className={styles.card}>
        {back && <Button {...back} variant="solid" buttonColor="text-1" />}
        {children}
        <div className={styles.footer}>
          <img src={logo} alt="Inform logo" className={styles.logo} />
        </div>
      </Card>
    </Section>
  );
}

export default CardLayout;
